import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  CLINICS_DELETE_CLINIC_BEGIN,
  CLINICS_DELETE_CLINIC_SUCCESS,
  CLINICS_DELETE_CLINIC_FAILURE,
  CLINICS_DELETE_CLINIC_DISMISS_ERROR,
} from './constants';
import ApiService from '../../../common/services/ApiService';

export function deleteClinic(clinicId, args) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CLINICS_DELETE_CLINIC_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.deleteClinic(clinicId, args).then(
        (res) => {
          dispatch({
            type: CLINICS_DELETE_CLINIC_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CLINICS_DELETE_CLINIC_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteClinicError() {
  return {
    type: CLINICS_DELETE_CLINIC_DISMISS_ERROR,
  };
}

export function useDeleteClinic() {
  const dispatch = useDispatch();

  const { deleteClinicPending, deleteClinicError } = useSelector(
    state => ({
      deleteClinicPending: state.clinics.deleteClinicPending,
      deleteClinicError: state.clinics.deleteClinicError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((clinicId, args) => {
    return dispatch(deleteClinic(clinicId, args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDeleteClinicError());
  }, [dispatch]);

  return {
    deleteClinic: boundAction,
    deleteClinicPending,
    deleteClinicError,
    dismissDeleteClinicError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLINICS_DELETE_CLINIC_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteClinicPending: true,
        deleteClinicError: null,
      };

    case CLINICS_DELETE_CLINIC_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteClinicPending: false,
        deleteClinicError: null,
      };

    case CLINICS_DELETE_CLINIC_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteClinicPending: false,
        deleteClinicError: action.data.error,
      };

    case CLINICS_DELETE_CLINIC_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteClinicError: null,
      };

    default:
      return state;
  }
}
